import { EModelApiPaths } from '../app/enums/EModelApiPaths';

export const environment = {
    MADHURAM_BE_HOST_PORT: 'https://madhuram.dev.be.savaapi.com',
    USER_PATH: 'adminmadhuram',
    production: true,
    INS: 'mongodb',
    DB: 'madhuram',
    authTokenInfo: 'madhuram_authorization', // it will be secret path.
    MADHURAM_BE_WS_HOST_PORT: 'wss://madhuram.dev.ws.savaapi.com',
    // MADHURAM_BE_WS_HOST_PORT: 'https://madhuram.dev.ws.savaapi.com',
    IS_ENCRYPTED: false,
    ENV: 'DEV', // DEV | QA | PROD
    BUCKET_NAME: 'sava-s3',
    FILE_PATH: 'madhuram-dev',
    FILE_URL: 'https://sava-s3.in-maa-1.linodeobjects.com/',
    PAYMENT_RECEIPTS: '/payment_receipts',

    crypto: {
        passJWT: '948b610b-af11-439c-8398-3eef252b9a77', // dev server
    },

    get MADHURAM_BE_HOST_PORT_SITES() {
        return this.MADHURAM_BE_HOST_PORT + `${EModelApiPaths.API}`;
    },
};
